<script setup>
import DeadAnimalStatistics from '@/views/DeadAnimalStatistics.vue';
import { useDisplay } from 'vuetify/lib/framework.mjs'

const { mobile } = useDisplay();
</script>

<template>
  <v-container
    fluid
    :class="mobile ? 'py-3 px-4' : 'py-4 px-8'"
  >
    <DeadAnimalStatistics
      :use-query="true"
      :pre-defined-days="28"
    />
  </v-container>
</template>

<style scoped>

</style>
